<div class="screen screen--install">

  <header class="gate__head">
    <button class="gate__back" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
      <i class="icon icon--arrow-left"></i>
    </button>
  </header>

  <header class="screen__head">
    <p class="belturo-eyebrow"><%= house %></p>
    <h1 class="screen__title"><%= _lcs( 'App installieren' ) %></h1>
  </header>

  <% if ( mode === 'installed' ) { %>

  <div class="gate__body">
    <span class="gate__icon"><i class="icon icon--circle-check"></i></span>
    <h2 class="gate__title"><%= _lcs( 'Die App ist installiert' ) %></h2>
    <p class="gate__text"><%= _lcs( 'Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.' ) %></p>
    <div class="gate__actions">
      <button class="btn btn--primary btn--lg btn--block" type="button" data-id="done"><%= _lcs( 'Zur Startseite' ) %></button>
    </div>
  </div>

  <% } else { %>

  <!-- Why — the same three things on every device. -->
  <ul class="install__perks">
    <li class="install__perk">
      <span class="install__perk-icon"><i class="icon icon--smartphone"></i></span>
      <span><%= _lcs( 'Direkt vom Home-Bildschirm starten' ) %></span>
    </li>
    <li class="install__perk">
      <span class="install__perk-icon"><i class="icon icon--monitor-smartphone"></i></span>
      <span><%= _lcs( 'Im Vollbild, ohne Browserleiste' ) %></span>
    </li>
    <li class="install__perk">
      <span class="install__perk-icon"><i class="icon icon--wifi-off"></i></span>
      <span><%= _lcs( 'Gästemappe auch ohne Internet' ) %></span>
    </li>
  </ul>

  <% if ( mode === 'prompt' ) { %>

  <div class="install__cta">
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="install">
      <i class="icon icon--download"></i> <%= _lcs( 'Jetzt installieren' ) %>
    </button>
    <p class="install__note"><%= _lcs( 'Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.' ) %></p>
  </div>

  <% } else if ( mode === 'ios' ) { %>

  <!-- iOS: no API, only Safari's own menus. Three steps, each with the glyph
       the guest is looking for on screen. -->
  <h2 class="install__subhead"><%= _lcs( 'So geht’s in drei Schritten' ) %></h2>
  <ol class="install__steps">
    <li class="install__step">
      <span class="install__step-num">1</span>
      <span class="install__step-text">
        <%= _lcs( 'Tippe auf „Teilen“' ) %> <i class="icon icon--share install__glyph" aria-hidden="true"></i>
        <span class="install__step-sub"><%= _lcs( 'In Safari unten in der Leiste, in anderen Browsern oben rechts.' ) %></span>
      </span>
    </li>
    <li class="install__step">
      <span class="install__step-num">2</span>
      <span class="install__step-text">
        <%= _lcs( 'Wähle „Zum Home-Bildschirm“' ) %> <i class="icon icon--plus install__glyph" aria-hidden="true"></i>
        <span class="install__step-sub"><%= _lcs( 'Falls du es nicht siehst, scrolle im Menü etwas nach unten.' ) %></span>
      </span>
    </li>
    <li class="install__step">
      <span class="install__step-num">3</span>
      <span class="install__step-text">
        <%= _lcs( 'Tippe oben rechts auf „Hinzufügen“' ) %>
        <span class="install__step-sub"><%= _lcs( 'Fertig — die App liegt jetzt auf deinem Home-Bildschirm.' ) %></span>
      </span>
    </li>
  </ol>

  <% } else { %>

  <p class="install__unsupported">
    <i class="icon icon--info"></i>
    <span><%= _lcs( 'Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.' ) %></span>
  </p>

  <% } %>

  <% } %>

</div>
